import React from 'react';
import './OtherOrders.css';
import * as translator from "../../../../utils/translator"

interface OtherOrdersProps {
    otherCountry:string;
    otherOrdersCount:number;
    language:string;
    otherCountryLanguage:string;
}

const OtherOrders: React.FC<OtherOrdersProps> = ({language, otherCountry, otherOrdersCount, otherCountryLanguage}) => {

  const handleClick = () => {
    (window as any).eventsTracking.setData('language', otherCountryLanguage);
  };

  return (
    <div className="account-other-orders">
        <div className="other-orders-text">
            <p className="other-orders-title">{translator.translate(language, "my_account", 'MyOrders/otherCountriesTitle')} ({otherCountry.toUpperCase()})</p>
            <p className="other-orders-description">{translator.translate(language, "my_account", 'MyOrders/otherCountriesSubTitle')}</p>
        </div>
        <div className="other-orders-links">
            <a 
              href={`/${otherCountry!}/account/my-orders`}
              onClick={handleClick}
              className="other-country-orders">

              {`${otherOrdersCount} ${translator.translate(language, "my_account", 'MyOrders/otherCountriesOrder')}`}
            </a>

        </div>
    </div>
  )
}

export default OtherOrders